export default class Mask{
    static normalizeTextUrl(text){  
        return text.normalize("NFD").replace(/[^a-zA-Z ]/g, "").replace(/(^\s+|\s+$)/, "").replace(/\s+/g, "-").toLowerCase();
    }

    static normalizeTextToCompare(text){  
        return text.normalize("NFD").replace(/[^a-zA-Z]/g, "").toLowerCase();
    }
}